// Core
import React from 'react';

function Icon(): JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      fill="none"
      data-testid="router-line-icon"
    >
      <path
        d="M9.00001 12V9H11V12H16C16.2652 12 16.5196 12.1054 16.7071 12.2929C16.8947 12.4804 17 12.7348 17 13V19C17 19.2652 16.8947 19.5196 16.7071 19.7071C16.5196 19.8946 16.2652 20 16 20H4.00001C3.73479 20 3.48044 19.8946 3.2929 19.7071C3.10537 19.5196 3.00001 19.2652 3.00001 19V13C3.00001 12.7348 3.10537 12.4804 3.2929 12.2929C3.48044 12.1054 3.73479 12 4.00001 12H9.00001ZM0.51001 6.837C1.83501 2.864 5.58401 0 10 0C14.416 0 18.166 2.864 19.49 6.837L17.592 7.469C17.0607 5.87573 16.0416 4.49 14.679 3.50805C13.3165 2.5261 11.6795 1.99771 10 1.99771C8.32049 1.99771 6.68353 2.5261 5.32097 3.50805C3.95842 4.49 2.93932 5.87573 2.40801 7.469L0.51101 6.837H0.51001ZM4.30601 8.102C4.70487 6.90741 5.46933 5.86853 6.49121 5.13239C7.51308 4.39625 8.74059 4.00015 10 4.00015C11.2594 4.00015 12.4869 4.39625 13.5088 5.13239C14.5307 5.86853 15.2952 6.90741 15.694 8.102L13.796 8.735C13.5301 7.93861 13.0205 7.24602 12.3392 6.75526C11.658 6.2645 10.8396 6.00043 10 6.00043C9.1604 6.00043 8.34206 6.2645 7.66081 6.75526C6.97956 7.24602 6.46991 7.93861 6.20401 8.735L4.30601 8.102ZM5.00001 14V18H15V14H5.00001Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default Icon;
